import { ServiceHelper2 } from "../../Common/_helpers/ServiceHelper2";
import { BUDGETS_API_URLS } from "../_constants/url.constants";

export const ProductsService = {
    listProducts,
    createNewProduct,
};

async function listProducts() {
    return await ServiceHelper2.getRequest(
        BUDGETS_API_URLS.PRODUCTS,
    );
}

async function createNewProduct({
    name,
    price,
    description
}) {
    return await ServiceHelper2.postRequest(
        BUDGETS_API_URLS.PRODUCTS,
        {
            name,
            price,
            description
        },
    );
}